export const contactsData = {
    email: "info@vellaphilip.com",
    phone: "+44 7### ######",
    address: "London, UK",
    sheetAPI: "",
};
